import React from 'react';
import { ENTITY_TYPE_LABEL_KEYS, type EntityType } from '../utils/entity-utils';
import { CONCEPT_ICONS, ENTITY_TYPE_LUCIDE_ICONS } from '../utils/concept-icons';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from './ui/tooltip';

interface EntityTypeIconProps {
  type: string;
  typeLabel: string;
  className?: string;
}

export const EntityTypeIcon: React.FC<EntityTypeIconProps> = ({
  type,
  typeLabel,
  className = 'h-3.5 w-3.5 shrink-0',
}) => {
  const Icon = ENTITY_TYPE_LUCIDE_ICONS[type as EntityType] ?? CONCEPT_ICONS.document;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex items-center">
          <Icon className={className} />
        </span>
      </TooltipTrigger>
      <TooltipContent side="top">
        <p>{typeLabel}</p>
      </TooltipContent>
    </Tooltip>
  );
};

export function getEntityTypeLabelKey(type: string): string {
  return ENTITY_TYPE_LABEL_KEYS[type as EntityType] ?? 'Documents';
}
